import {translateRoleLevel} from './utils/auth';

export const trackEvent = (eventName, props = {}) =>
  window.analytics.track(`[account] ${eventName}`, {
    appName: 'Account',
    path: window.location.hash.replace(/^#/, ''),
    ...props,
  });

export const trackPage = () => {
  window.analytics.page('Planet Account');
};

export const identify = ({
  user_id,
  email,
  organization_id,
  program_id,
  role_level,
}) => {
  const options = {
    Intercom: {
      hideDefaultLauncher: true,
    },
  };

  window.analytics.identify(
    user_id,
    {
      email,
      userId: user_id,
      organizationId: organization_id,
      programId: program_id,
      roleLevel: role_level,
      role: translateRoleLevel(role_level),
    },
    options
  );
};

export const reset = () => window.analytics.reset();
